(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("styled-components"), require("icepath"), require("polished"));
	else if(typeof define === 'function' && define.amd)
		define("statlibs", ["styled-components", "icepath", "polished"], factory);
	else if(typeof exports === 'object')
		exports["statlibs"] = factory(require("styled-components"), require("icepath"), require("polished"));
	else
		root["statlibs"] = factory(root["styled-components"], root["icepath"], root["polished"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_5__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 37);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollWidth; });
/* harmony export (immutable) */ __webpack_exports__["a"] = fixMediaQuery;
var fixed = false;
var scrollWidth = function () {
  if (!window.document) return 0;
  var html = document.documentElement;
  var oldOverflow = html.style.overflowY;
  html.style.overflowY = 'scroll';
  var width = window.innerWidth - html.clientWidth;
  html.style.overflowY = oldOverflow;
  return width;
}();

var fixMediaQueryFn = function fixMediaQueryFn() {

  var fontSize = parseFloat(window.getComputedStyle(document.body).getPropertyValue('font-size'));

  if (scrollWidth > 0) {

    [].slice.call(document.styleSheets).filter(function (styleSheet) {
      return isValidExternal(styleSheet) || isInline(styleSheet);
    }).forEach(function (stylesheet) {
      try {
        [].slice.call(stylesheet.cssRules || stylesheet.media).filter(function (rule) {
          return rule.constructor === window.CSSMediaRule;
        }).forEach(function (rule) {
          rule.media.mediaText = rule.media.mediaText.replace(/m(in|ax)-width:\s*(\d|\.)+(px|em)/gi, function (strA) {
            if (strA.match('px')) {
              return strA.replace(/\d+px/gi, function (strB) {
                return parseInt(strB, 10) + scrollWidth + 'px';
              });
            } else {
              return strA.replace(/\d.+?em/gi, function (strB) {
                return (parseFloat(strB) * fontSize + scrollWidth) / fontSize + 'em';
              });
            }
          });
        });
      } catch (e) {}
    });
  }

  fixed = true;

  function sameOrigin(url) {
    var loc = window.location,
        a = document.createElement('a');
    a.href = url;
    return a.hostname === loc.hostname && a.protocol === loc.protocol;
  }

  function isInline(stylesheet) {
    return stylesheet.ownerNode.constructor === HTMLStyleElement;
  }

  function isValidExternal(stylesheet) {
    return stylesheet.href && sameOrigin(stylesheet.href);
  }
};

function fixMediaQuery() {
  if (fixed || !document || !document.readyState) return;
  if (process.env.NODE_ENV === 'test') {
    return;
  }
  if (document.readyState !== 'loading') {
    fixMediaQueryFn();
  } else {
    document.addEventListener('DOMContentLoaded', fixMediaQueryFn);
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return intToHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return intsToHour; });
/* harmony export (immutable) */ __webpack_exports__["j"] = isSmallDevice;
/* harmony export (immutable) */ __webpack_exports__["g"] = isHighDensity;
/* harmony export (immutable) */ __webpack_exports__["i"] = isRetina;
/* harmony export (immutable) */ __webpack_exports__["h"] = isMobile;
/* harmony export (immutable) */ __webpack_exports__["k"] = isTouchDevice;
/* harmony export (immutable) */ __webpack_exports__["a"] = addHttp;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return linkRegex; });
/* harmony export (immutable) */ __webpack_exports__["l"] = isUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = ellipsis;
/* harmony export (immutable) */ __webpack_exports__["p"] = safeNewLineToBr;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return digitsToPattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getClosestOffsetScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return normalizeTouch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return normalizeMouse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fixMediaQuery__ = __webpack_require__(16);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



var intToHour = function intToHour(hour) {
  var autoFill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (hour === undefined) return '';
  if (autoFill) return ('000' + hour.toString()).slice(-4).replace(/(\d\d)(\d\d)/, '$1:$2');
  var h = hour.toString().slice(-4, -2);
  var m = hour.toString().slice(-2);
  if (h) return (parseInt(h, 10) > 23 ? h.slice(1) : h) + ':' + m;
  return m;
};

var intsToHour = function intsToHour(_ref) {
  var open = _ref.open,
      close = _ref.close;
  return intToHour(open) + ' - ' + intToHour(close);
};

function isSmallDevice() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 600;

  var smallDeviceQuery = window.matchMedia ? window.matchMedia('(max-width: ' + (width + __WEBPACK_IMPORTED_MODULE_0__fixMediaQuery__["b" /* scrollWidth */]) + 'px)') : { matches: false };
  return smallDeviceQuery.matches;
}

function isHighDensity() {
  return window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
}

function isRetina() {
  return (window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches) || window.devicePixelRatio && window.devicePixelRatio >= 2) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
}

function isMobile() {
  var check = false;
  if (typeof navigator === 'undefined') {
    return false;
  }
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ -/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ /])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window['opera']);
  return check;
}

function isTouchDevice() {
  return window.document && 'ontouchstart' in window.document.documentElement;
}

function addHttp(s) {
  s = (s || '').trim();
  if (s.indexOf('http://') === 0 || s.indexOf('https://') === 0) {
    return s;
  } else {
    return 'http://' + s;
  }
}

// export function insertAfter(newNode: HTMLElement,node: HTMLElement) {
//   if (node.nextSibling) {
//     (node.parentNode:any).insertBefore(newNode,node.nextSibling)
//   } else {
//     (node.parentNode:any).appendChild(newNode)
//   }
// }

var protocols = '(^|\\s|\xA0)(https?://)?(www\\.)?';
var subdomains = '([a-zA-Z0-9][a-zA-Z0-9-_]*[a-zA-Z0-9]?\\.)*';
var domain = '(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\\.([a-zA-Z]{2,6}|[a-zA-Z0-9-]{2,30}\\.[a-zA-Z]{2,3})';
var resource = '[\xA1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zA-Z0-9-._~:/?#%[\\]@!$&\'()*+,;=]*';
var linkRegex = new RegExp(protocols + subdomains + domain + resource);

function isUrl(url) {
  return linkRegex.test(addHttp(url));
}

function ellipsis() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var length = arguments[1];

  if (str.length > length) {
    var words = str.slice(0, length).split(' ');
    if (str.split(' ').indexOf(words[words.length - 1]) < 0) words = words.slice(0, words.length - 1);
    return words.join(' ') + '...';
  } else return str;
}

function safeNewLineToBr(str) {
  return (str || "").replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/\n+/g, '<br/>');
}

function padGroups(pattern, value) {
  return pattern.split('').reduce(function (_ref2, char, i) {
    var _ref3 = _slicedToArray(_ref2, 2),
        acc = _ref3[0],
        value = _ref3[1];

    if (char === '0') {
      var shouldHave = pattern.slice(i).search(/[^0#?*]/);
      var has = value.slice(i).search(/\D/);
      if (has > 0 && shouldHave > has) {
        return [acc.concat('0'), acc.join('') + '0' + value.slice(i)];
      } else {
        return [acc.concat(value[i]), value];
      }
    } else {
      return [acc.concat(value[i]), value];
    }
  }, [[], value])[0].join('');
}

var digitsToPattern = function digitsToPattern(patternWithLimit, optValue) {
  var value = optValue || "";
  if (patternWithLimit[0] === '>' && Number(patternWithLimit.replace(/^>(\d*).*/g, "$1")) > value.length) return value;
  var pattern = patternWithLimit.replace(/^>\d+/, '');
  var digits = padGroups(pattern, value).replace(/\D/g, '');
  var totalRequired = pattern.split(/[0#]/).length - 1;
  var totalOptional = pattern.split(/[?*]/).length - 1;
  var available = digits.length - totalRequired;

  if (available > 0 && totalOptional > 0) {
    var _i = 0;
    return digitsToPattern(pattern.replace(/\?/g, function () {
      return _i++ < available ? '#' : '';
    }).replace('*', new Array(Math.max(0, available - _i + 1)).join("#")), value);
  }
  var i = 0;
  return pattern.replace(/^>\d*/, '').split('').reduce(function (acc, char) {
    if (!digits[Math.max(i - 1, 0)] || char === '?' || char === '*') return acc;
    if (char === '#' || char === '0') {
      return acc + (digits[i++] || '');
    } else {
      return acc + char;
    }
  }, '');
};

var getClosestOffsetScroll = function getClosestOffsetScroll(node) {
  if (!node) {
    return document.body;
  }
  var overflowY = window.getComputedStyle(node).overflowY;
  var isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';
  if (isScrollable && node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getClosestOffsetScroll(node.offsetParent);
  }
};

var normalizeTouch = function normalizeTouch(fn, endFn) {
  return function (e) {
    var touch = e.touches[0];
    if (e.touches.length > 1) {
      endFn();
    } else {
      fn(e.currentTarget, touch.pageX, touch.pageY, touch.clientX, touch.clientY, e);
    }
  };
};

var normalizeMouse = function normalizeMouse(fn) {
  return function (e) {
    fn(e.currentTarget, e.pageX, e.pageY, e.clientX, e.clientY, e);
  };
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_styled__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_fixMediaQuery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_smoothScroll__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_index__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getProp", function() { return __WEBPACK_IMPORTED_MODULE_0__lib_styled__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "media", function() { return __WEBPACK_IMPORTED_MODULE_0__lib_styled__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ifProp", function() { return __WEBPACK_IMPORTED_MODULE_0__lib_styled__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getMargin", function() { return __WEBPACK_IMPORTED_MODULE_0__lib_styled__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getColor", function() { return __WEBPACK_IMPORTED_MODULE_0__lib_styled__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "customTheme", function() { return __WEBPACK_IMPORTED_MODULE_0__lib_styled__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fixMediaQuery", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_fixMediaQuery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scrollWidth", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_fixMediaQuery__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMobile", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "digitsToPattern", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getClosestOffsetScroll", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isHighDensity", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isRetina", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSmallDevice", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isTouchDevice", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkRegex", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "intsToHour", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "intToHour", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeTouch", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeMouse", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addHttp", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ellipsis", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isUrl", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "safeNewLineToBr", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_index__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "smoothScroll", function() { return __WEBPACK_IMPORTED_MODULE_2__lib_smoothScroll__["a"]; });








/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return smoothScroll; });

// Get the top position of an element in the document
var getTop = function getTop(element, start) {
  // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
  if (!element || element.nodeName === 'HTML') return -start;
  return element.getBoundingClientRect().top + start;
};
// ease in out function thanks to:
// http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
var easeInOutCubic = function easeInOutCubic(t) {
  return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};

// calculate the scroll position we should be in
// given the start and end point of the scroll
// the time elapsed from the beginning of the scroll
// and the total duration of the scroll (default 500ms)
var position = function position(start, end, elapsed, duration) {
  if (elapsed > duration) return end;
  return start + (end - start) * easeInOutCubic(elapsed / duration); // <-- you can change the easing funtion there
  // return start + (end - start) * (elapsed / duration); // <-- this would give a linear scroll
};

// we use requestAnimationFrame to be called by the browser before every repaint
// if the first argument is an element then scroll to the top of this element
// if the first argument is numeric then scroll to this location
// if the callback exist, it is called when the scrolling is finished
// if context is set then scroll that element, else scroll window
var smoothScroll = function smoothScroll(el) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var callback = arguments[2];
  var ctx = arguments[3];

  var context = ctx || window;
  var start = context.scrollTop || window.pageYOffset;
  var offset = el instanceof HTMLElement ? 0 : el.offset || 0;

  var end = offset + (typeof el === 'number' ? Math.round(el) : el instanceof HTMLElement ? getTop(el, start) : getTop(el.target, start));

  var clock = Date.now();
  var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
    window.setTimeout(fn, 15);
  };

  var step = function step() {
    var elapsed = Date.now() - clock;
    if (context !== window) {
      context.scrollTop = position(start, end, elapsed, duration);
    } else {
      window.scroll(window.pageXOffset, position(start, end, elapsed, duration));
    }

    if (elapsed > duration) {
      if (typeof callback === 'function') {
        callback(el);
      }
    } else {
      requestAnimationFrame(step);
    }
  };
  step();
};

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMargin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ifProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return media; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_polished__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styled_components__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    @media screen and (max-width: 600px) {\n      ', '\n    }\n  '], ['\n    @media screen and (max-width: 600px) {\n      ', '\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    @media screen and (min-width: 601px) {\n      ', '\n    }\n  '], ['\n    @media screen and (min-width: 601px) {\n      ', '\n    }\n  ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var getColor = function getColor(propsOrColor, hover) {
  if (typeof propsOrColor === 'string') {
    return function (_ref) {
      var theme = _ref.theme;
      return theme.colors[propsOrColor];
    };
  }

  var theme = propsOrColor.theme,
      props = _objectWithoutProperties(propsOrColor, ['theme']);

  if (props.dark) {
    return __WEBPACK_IMPORTED_MODULE_1_polished__["darken"](0.1, getColor(_extends({ theme: theme }, __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].unset(props, 'dark'))));
  } else if (hover && props.hover) {
    return getColor({ theme: theme, color: props.hover });
  } else if (props.color) {
    return theme.colors[props.color] || props.color;
  } else if (props.highlight) {
    return theme.colors.main;
  } else if (props.alert) {
    return theme.colors.alert;
  } else if (props.success) {
    return theme.colors.success;
  } else {
    return theme.colors.gray150;
  }
};


var getMargin = function getMargin(enumeratedMargins) {
  return function (props) {
    return enumeratedMargins[props.margin] || props.margin || enumeratedMargins['default'] || 0;
  };
};

/**
 * Returns the value of `props[path]` or `defaultValue`
 * @example
 * const Button = styled.button`
 *  color: ${prop('color', 'red')};
 * `
 */
var getProp = function getProp(path, defaultValue) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].get(props, [].concat(path)) || defaultValue;
  };
};

var customTheme = function customTheme(type) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].get(props, ["theme", "startlibs", type]) || '';
  };
};

/**
 * Returns `pass` if prop is truthy. Otherwise returns `fail`
 * @example
 * // usage with styled-theme
 * import styled from 'styled-components'
 * import { ifProp } from 'styled-tools'
 * import { palette } from 'styled-theme'
 *
 * const Button = styled.button`
 *  background-color: ${ifProp('transparent', 'transparent', palette(0))};
 *  color: ${ifProp(['transparent', 'accent'], palette('secondary', 0))};
 *  font-size: ${ifProp({ size: 'large' }, '20px', ifProp({ size: 'medium' }, '16px', '12px'))};
 *`
 */
var ifProp = function ifProp(path, pass, fail) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var result = false;
    if (Array.isArray(path)) {
      result = path.every(function (p) {
        return testSinglePath(props, p);
      });
    } else if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object') {
      result = !Object.entries(path).find(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            k = _ref3[0],
            v = _ref3[1];

        return props[k] !== v;
      });
    } else {
      result = testSinglePath(props, path);
    }
    return result ? pass : fail;
  };
};

var media = {
  mobile: function mobile() {
    return __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"](_templateObject, __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"].apply(undefined, arguments));
  },
  desktop: function desktop() {
    return __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"](_templateObject2, __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"].apply(undefined, arguments));
  }
};

function testSinglePath(props, path) {
  if (typeof path === 'string') {
    return !!__WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].get(props, path);
  } else if (typeof path === 'number') {
    return !!props[path];
  } else {
    return false;
  }
}

/***/ })

/******/ });
});
//# sourceMappingURL=lib.js.map


//////////////////
// WEBPACK FOOTER
// ./~/startlibs/lib/lib.js
// module id = 9
// module chunks = 4